import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, del } from './agent';

const memberFiles =
  (memberFilesUrl) =>
  (id = '') => {
    const url = _([memberFilesUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      upload: (body) => post(url, body),
      delete: () => del(url),
    };
  };

export default memberFiles;
